// @flow
import React from 'react';
import { Row, Col, Card, Button } from 'react-bootstrap';
import { useAuth } from '../../providers/CustomAuthProvider';

const NotAuthorised = () => {
    const { logout } = useAuth();

    const logoutWithRedirect = () => logout({ returnTo: `https://${window.location.host}` });

    return (
        <React.Fragment>
            <div className="pt-2 pt-sm-5 pb-4 pb-sm-5">
                <div className="container">
                    <Row className="justify-content-center">
                        <Col md={8} lg={6} xl={5}>
                            <Card>
                                <Card.Body className="p-4">
                                    <div className="text-center">
                                        <h4 className="text-uppercase text-danger mt-3">Not Authorized!</h4>
                                        <p className="text-muted mt-3">
                                            It seems you are not authorized to access datahub. Contact your administrator if you think you need access to datahub.
                                        </p>
                                        <Button variant="primary" className="mt-3" onClick={logoutWithRedirect}>
                                            <i className="mdi mdi-reply"></i> Login Again
                                        </Button>
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </div>
            </div>
        </React.Fragment>
    );
};

export default NotAuthorised;
